import type { TSocialProofCardProps } from "../SocialProofCard.config";
import type { DefinedDefaults, TWithDataComponent } from "@/ui/lib/types";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const SCROLLABLE_SOCIAL_PROOF_CARDS_LIST_CLASS = "w-max pr-4";

/*-------------------------------------
|  Types
-------------------------------------*/

export type TSocialProofCardItems = readonly TSocialProofCardProps [];

export type TScrollableSocialProofCardsProps = TWithDataComponent & {
  items: TSocialProofCardItems;
};

type TScrollableSocialProofCardsDefaultProps = DefinedDefaults<
  TScrollableSocialProofCardsProps,
  "data-component"
>;

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const SCROLLABLE_SOCIAL_PROOF_CARDS_DEFAULTS = {
  "data-component": "ScrollableSocialProofCards",
} satisfies TScrollableSocialProofCardsDefaultProps;
